import { gql } from '@apollo/client';

/**
 * GraphQL subscriptions for real-time property updates
 */
export const PROJECT_PROPERTY_SUBSCRIPTION = gql`
  subscription projectPropertyUpdates($projectId: ID!) {
    projectPropertyUpdates(projectId: $projectId) {
      identifier
      value
      valueType
      propertyType
      propertyIdentifier
    }
  }
`;

export const ORGANIZATION_PROPERTY_SUBSCRIPTION = gql`
  subscription organizationPropertyUpdates($organizationId: ID!) {
    organizationPropertyUpdates(organizationId: $organizationId) {
      identifier
      value
      valueType
      propertyType
      propertyIdentifier
    }
  }
`;

export const USER_PROPERTY_SUBSCRIPTION = gql`
  subscription userPropertyUpdates($userId: ID!) {
    userPropertyUpdates(userId: $userId) {
      identifier
      value
      valueType
      propertyType
      propertyIdentifier
    }
  }
`;

/**
 * GraphQL fragment for property state
 */
export const PROJECT_PROPERTY_STATE_FRAGMENT = gql`
  fragment ProjectPropertyState on Project {
    id
    stateByUser {
      userId
      properties {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
    state {
      properties {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
  }
`;

/**
 * Project Properties Queries and Mutations
 */

export const GET_PROJECT_PROPERTIES = gql`
  query getProjectProperties($projectId: ID!) {
    projectById(projectId: $projectId) {
      id
      stateByUser {
        userId
        properties {
          propertyIdentifier
          properties {
            identifier
            value
            valueType
            createdAt
            updatedAt
          }
        }
      }
      state {
        properties {
          propertyIdentifier
          properties {
            identifier
            value
            valueType
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_PROPERTIES_FOR_OBJECTS = gql`
  query getProjectPropertiesForObjects($projectId: ID!, $propertyIdentifiers: [String!]) {
    projectById(projectId: $projectId) {
      id
      stateByUser {
        userId
        properties(propertyIdentifiers: $propertyIdentifiers) {
          propertyIdentifier
          properties {
            identifier
            value
            valueType
            createdAt
            updatedAt
          }
        }
      }
      state {
        properties(propertyIdentifiers: $propertyIdentifiers) {
          propertyIdentifier
          properties {
            identifier
            value
            valueType
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_PROPERTY_STATE = gql`
  ${PROJECT_PROPERTY_STATE_FRAGMENT}
  query getProjectPropertyState($projectId: ID!) {
    projectById(projectId: $projectId) {
      ...ProjectPropertyState
    }
  }
`;

export const PROJECT_UPDATE_PROPERTY = gql`
  mutation projectUpdateProperty($projectId: ID!, $identifier: String!, $value: PropertyValue!, $propertyType: PropertyType!, $propertyIdentifier: String!, $valueType: PropertyValueType!) {
    projectUpdateProperty(projectId: $projectId, identifier: $identifier, value: $value, propertyType: $propertyType, propertyIdentifier: $propertyIdentifier, valueType: $valueType) {
      id
    }
  }
`;

export const PROJECT_BATCH_UPDATE_PROPERTIES = gql`
  mutation projectBatchUpdateProperties($projectId: ID!, $updates: [PropertyUpdateInput!]!) {
    projectBatchupdateProperties(projectId: $projectId, updates: $updates) {
      id
    }
  }
`;

/**
 * Organization Properties Queries and Mutations
 */

export const GET_ORGANIZATION_PROPERTIES = gql`
  query getOrganizationProperties($organizationId: ID!) {
    organisationById(organisationId: $organizationId) {
      id
      properties {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const ORGANIZATION_UPDATE_PROPERTY = gql`
  mutation organizationUpdateProperty($organizationId: ID!, $identifier: String!, $value: PropertyValue!, $propertyIdentifier: String!, $valueType: PropertyValueType!) {
    organizationUpdateProperty(organizationId: $organizationId, identifier: $identifier, value: $value, propertyIdentifier: $propertyIdentifier, valueType: $valueType)
  }
`;

export const ORGANIZATION_BATCH_UPDATE_PROPERTIES = gql`
  mutation organizationBatchUpdateProperties($organizationId: ID!, $updates: [PropertyUpdateInput!]!) {
    organizationBatchUpdateProperties(organizationId: $organizationId, updates: $updates)
  }
`;

/**
 * User Properties Queries and Mutations
 */

export const GET_USER_PROPERTIES = gql`
  query getUserProperties {
    currentUser {
      id
      properties {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const USER_UPDATE_PROPERTY = gql`
  mutation userUpdateProperty($identifier: String!, $value: PropertyValue!, $propertyIdentifier: String!, $valueType: PropertyValueType!) {
    userUpdateProperty(identifier: $identifier, value: $value, propertyIdentifier: $propertyIdentifier, valueType: $valueType)
  }
`;

export const USER_BATCH_UPDATE_PROPERTIES = gql`
  mutation userBatchUpdateProperties($updates: [PropertyUpdateInput!]!) {
    userBatchUpdateProperties(updates: $updates)
  }
`;

/**
 * Property Updates Subscription
 */
export const PROPERTY_UPDATES_SUBSCRIPTION = gql`
  subscription projectPropertyUpdates($projectId: ID!) {
    projectPropertyUpdates(projectId: $projectId) {
      identifier
      value
      valueType
      propertyType
      propertyIdentifier
    }
  }
`;
